import { Dispatch } from 'react';
import { get, remove, put, post } from 'communication/httpClient';
import {
  GET_TENDER_MENUS,
  ERROR_DATA,
  DELETE_TENDER_MENU,
  SAVE_TENDER_MENU,
  UPDATE_TENDER_MENU,
  SYNCING,
  TENDER_MENU_LOADED,
  RESET_TENDER_MENU,
} from './actionTypes';
import { ITenderMenuAction, ITenderMenuActions, ITenderMenuItem } from './types';

export const getActions = (dispatch: Dispatch<ITenderMenuAction>): ITenderMenuActions => ({
  loadTenderMenus: async () => {
    dispatch({
      type: SYNCING,
    });
    const { data, error } = await get(`/api/tender-menu`);
    if (data) {
      dispatch({
        type: GET_TENDER_MENUS,
        payload: data,
      });
    } else {
      dispatch({
        type: ERROR_DATA,
        payload: error,
      });
    }
  },
  loadTenderMenu: async (id) => {
    dispatch({
      type: SYNCING,
    });
    const { data, error } = await get(`/api/tender-menu/${id}`);
    if (data) {
      dispatch({
        type: TENDER_MENU_LOADED,
        payload: data,
      });
    } else {
      dispatch({
        type: ERROR_DATA,
        payload: error,
      });
    }
  },
  deleteTenderMenu: async (id, callback) => {
    const { error } = await remove(`/api/tender-menu/${id}`);
    if (!error) {
      dispatch({
        type: DELETE_TENDER_MENU,
        payload: id,
      });
      if (callback) {
        callback();
      }
    } else {
      dispatch({
        type: ERROR_DATA,
        payload: error,
      });
    }
  },
  saveTenderMenus: async (tenderMenu: ITenderMenuItem, isNew, callback) => {
    dispatch({
      type: SYNCING,
    });
    const handler = isNew ? post : put;
    const type = isNew ? SAVE_TENDER_MENU : UPDATE_TENDER_MENU;
    const { data, error, success } = await handler(`/api/tender-menu`, tenderMenu);
    if (data || !error) {
      dispatch({
        type,
        payload: tenderMenu,
      });
    } else {
      dispatch({
        type: ERROR_DATA,
        payload: error,
      });
    }
    if (success && callback) {
      callback();
    }
  },
  resetTenderMenu: () =>
    dispatch({
      type: RESET_TENDER_MENU,
    }),
});
